export default __webpack_public_path__ + "static/media/billboard_placeholder.c224be1a.svg";